import { useForm } from "react-hook-form";
import { gql, useQuery } from "@apollo/client";
import { UPDATE_TIER_DETAILS, GET_NEXT_ORDER } from "./query";
import { FormContainer, TextInput, SelectInput } from "../shared";
import useGlobalMutation from "../../hooks/useGlobalMutation";
import { RegexPattern } from "../../utils";
import { clearCache } from "../../utils/cacheUtils";

interface UpdateTierDetailsProps {
    id: string;
    tierName: string;
    orderNo: number;
    country: string;
    onUpdateSuccess: () => void;
}

const UpdateTierDetails = ({
    id,
    tierName,
    orderNo,
    country,
    onUpdateSuccess,
}: UpdateTierDetailsProps) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            tierName,
            orderNo,
        },
    });

    const { submitMutation, loading } = useGlobalMutation(UPDATE_TIER_DETAILS, (cache: any) => {
        clearCache(cache, "allAllerganProTiers");
    });

    const { data: maxTierOrder } = useQuery(gql(GET_NEXT_ORDER), { variables: { country } });

    const maxOrderNumber = maxTierOrder?.allAllerganProTiers?.nodes?.[0]?.orderNo || orderNo;

    const submitAction = handleSubmit(async (data) => {
        const { tierName, orderNo } = data;

        const variables = {
            id,
            tierName,
            orderNo: Number(orderNo),
        };

        const dataPath = "updateAllerganProTierById.allerganProTier";
        await submitMutation(variables, dataPath, "Tier Updated Successfully");

        onUpdateSuccess?.();
    });

    return (
        <FormContainer
            submitAction={submitAction}
            loading={loading}
            submitButtonText="Update"
            submitBtnSm
        >
            <h5 className="mb-3">Update Tier</h5>
            <div className="row">
                <div className="col-md-6">
                    <TextInput
                        id="tierName"
                        labelText="Name"
                        {...register("tierName", {
                            pattern: RegexPattern.name,
                            required: true,
                        })}
                        isInvalid={!!errors.tierName}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <SelectInput
                        id="orderNo"
                        labelText="Order"
                        options={Array.from(Array(maxOrderNumber).keys()).map((number) => ({
                            id: (number + 1).toString(),
                            name: (number + 1).toString(),
                        }))}
                        {...register("orderNo", {
                            required: true,
                        })}
                        isInvalid={!!errors.orderNo}
                        required
                    />
                </div>
            </div>
        </FormContainer>
    );
};

export default UpdateTierDetails;
